import React from "react";
import { Function0 } from "lodash";
import { Modal } from "react-bootstrap";

import { CloseButton, Button, TextWithLoader } from "components";
import { getFullName, useGetUserUrl } from "helpers";

import styles from "./residualsModal.module.scss";

type ResidualsStatusChangingModalProps = {
	show: boolean;
	onHide: () => void;
	onCancel?: Function0<void>;
	data: { [key: string]: any };
};

const ResidualsStatusChangingModal = ({
	show,
	onHide,
	onCancel,
	data,
}: ResidualsStatusChangingModalProps) => {
	const handleClose = () => {
		onHide();
		onCancel?.();
	};

	const linkToAssignedUser = useGetUserUrl(
		data?.changedResidualStatusByUser,
		data?.changedResidualStatusByUser?.id,
	);

	return (
		<Modal
			show={show}
			onHide={handleClose}
			centered
			animation={false}
			size="lg"
			className={styles.centeredLabelsModal}
		>
			<Modal.Header>
				<Modal.Title as="h6" className="text-center">
					Residuals Status Changing
				</Modal.Title>
				<CloseButton onClick={handleClose} />
			</Modal.Header>
			<Modal.Body className={styles.bodyInner}>
				<TextWithLoader
					label="Residuals Status: "
					value={
						data?.residualsStatus === "Withhold residuals"
							? "Withhold"
							: data?.residualsStatus
					}
					className={styles.row}
					labelClass={styles.label}
					valueClass={`${styles.value} pl-2 py-0`}
					labelCol={6}
					valueCol={6}
				/>
				<TextWithLoader
					label="Status Previously Changed By: "
					value={getFullName(data?.changedResidualStatusByUser)}
					className={styles.row}
					labelClass={styles.label}
					valueClass={`${styles.value} pl-2 py-0`}
					linkTo={linkToAssignedUser}
					target="_blank"
					labelCol={6}
					valueCol={6}
				/>
				<hr className="line mt-4" style={{ width: "30%" }} />
				<div className={`${styles.containerAlertText} pl-2 pr-2`}>
					<p className={styles.title}>
						Please contact the user who previously changed the
						status of residuals and confirm that it is possible to
						change the status to pay residuals.
					</p>
				</div>
			</Modal.Body>
			<Modal.Footer className="d-flex justify-content-center mb-4">
				<Button
					onClick={handleClose}
					value="Cancel"
					variant="outline-primary"
					className="mr-4"
				/>
				<Button value="Save changes" onClick={onHide} />
			</Modal.Footer>
		</Modal>
	);
};

export default ResidualsStatusChangingModal;
